// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //fcApiUrl:'https://demo.fundcore.in', 
  // fcApiUrl: 'https://fundcore-test-app.azurewebsites.net',
  // clientKey: 'gws',
  // clientAuthKey: 'testuser:@123456#', 

  //For invest4edu
  // fcApiUrl:'https://investments.invest4edu.com',
  // clientKey: 'invest4edu',
  // clientAuthKey:'i4eduapiuser:!@edu$os&hts',

  // For Nirmalbang
  // fcApiUrl: 'https://mflogin.nirmalbang.com',
  // clientKey: 'buckfast',
  // clientAuthKey: 'nirmalbang001:nb@#007',

  // For Nirmalbang UAT
  // fcApiUrl: 'https://uatmflogin.nirmalbang.com',
  // clientKey: 'buckfast',
  // clientAuthKey: 'nb_8547:CA54UJY4TR@I1UQHH47Y',

  // For Kunvarji
  // fcApiUrl:'https://mf.kunvarjiwealth.com',
  // clientKey: 'kunvarji_wealth',
  // clientAuthKey:'kunvarji_9361:6Ig5@ew7RfzV3HkkF7sUA#1h2tC7uk',

  //For Centrum
  // fcApiUrl:'https://mutualfund-api-uat.centrumgalaxc.com',
  // fcApiUrlSSO:'https://mutualfund-uat.centrumgalaxc.com',  
  // clientKey: 'centrum_galaxc',
  // clientAuthKey:'CentrumLive03012025:K6pwSt6U64j)J,z24Wq',  

  //live
  // fcApiUrl:'https://mutualfund-api.centrumgalaxc.com',
  // fcApiUrlSSO:'https://mutualfund.centrumgalaxc.com', 
  // clientKey: 'centrum_galaxc',
  // clientAuthKey:'CentrumLive03012025:K6pwSt6U64j)\\J,z24Wq',   //Added double slash for escape character

  //For way2wealth
  fcApiUrl:'https://wealth.way2wealth.com',
  clientKey: 'way2wealth',
  clientAuthKey:'w2w_apiuser:@123456#',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
